module.exports = __webpack_public_path__ + "static/client-pemkot-blora-b120d9a859ee9eb43a4f88fe38f619d8.png";